import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import {
  SetTheSiteTransferActions,
  setTheoptions,
  setThecountBasedRenders,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  getSideBarfilesActions,
  setTheStatusFilter,
  setDropDownRenders , 



  setTheSiteTransferState,
  setTheSiteTransferRegion,
  setTheSiteTransferZone,
  setheSiteTransferdesignationStatus,
  setTheSiteTransferStateStatus,
  setTheSiteTransferRange1,
  setTheSiteTransferRange2,
  setTablePositionPersist

} from "../../../Redux/Slice";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import SiteTransferApprove from "./SiteTransferApprove";
import SiteCreateEdit from "./SiteCreateEdit";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";

import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import useDebouncedEffect from 'use-debounced-effect';

const SiteTransfer = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const UserObjectData = useSelector((state) => state.users.UserData);
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  )

const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.SitetransferlistRequestedPagelist?.page == undefined
      ? 1
      : TablePositionPersist.SitetransferlistRequestedPagelist.page
  ); 
  const [search, setsearch] = useState(
    TablePositionPersist?.SitetransferlistRequestedPagelist?.search == undefined ||
    TablePositionPersist?.SitetransferlistRequestedPagelist?.search ==""
      ? ""
      : TablePositionPersist.SitetransferlistRequestedPagelist.search
  ); 

  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const state = useSelector((state) => state);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [createpoup, setcreatepoup] = useState(false);

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  const [sno, setsno] = useState(0);


  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.StateManagementOverallCall.Site_TransferRange1);
  var gt = convert(state.StateManagementOverallCall.Site_TransferRange2);
  const [range, setrange] = useState(
    state.StateManagementOverallCall.Site_TransferRange1 == ""
      ? // [it, gt]
        []
      : [it, gt]
  );

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheSiteTransferRange1(range[0]));
      dispatch(setTheSiteTransferRange2(range[1]));
    }
  }, [range]);


  useEffect(() => {
    dispatch(setDropDownRenders(""))
    //  if(state.ClientBranchIDs.DashboardIDs == 3  ){
    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options[0]));
      SetPlace("All");
      SetSelectval({
        ///Completed
        ...selectVal,
        is_pending: "",
        is_decline: "",
        approved: "",
      });
       const StatusFilter ={        is_pending: "",
        is_decline: "",
        approved: "",}
       
      dispatch(setTheStatusFilter(StatusFilter))
    }
    if (state.NumberCounts.namerednder == "completed") {
      dispatch(setTheoptions(options[1]));
      SetPlace("Approved");

      SetSelectval({
        ///Completed
        ...selectVal,
        // is_pending: false,
        // is_decline: false,
        // approved: "",
        is_pending: "",
        is_decline: "",
        approved: true,
      });

      const StatusFilter ={        is_pending: "",
        is_decline: "",
        approved:true}
       
      dispatch(setTheStatusFilter(StatusFilter))


    }
    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Decline");

      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
      });

      const StatusFilter ={        is_pending: "",
        is_decline: true,
        approved:""}
       
      dispatch(setTheStatusFilter(StatusFilter))

      
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Pending");
      SetSelectval({
        ...selectVal,
        is_pending: true,
        is_decline: "",
        approved: "",
      });

      const StatusFilter ={        is_pending: true,
        is_decline: "",
        approved:""}
       
      dispatch(setTheStatusFilter(StatusFilter))


    }
    // }
  }, [state.NumberCounts.namerednder]);


  
  const [filterForWhite, setFilters] = useState({ white_collar: 

    state.StateManagementOverallCall.Site_Transferdesignation?.value == ""?
    "":
    state.StateManagementOverallCall.Site_Transferdesignation?.value == 1 ?
    true:
    false

  });
  const HandleEMprole = (e) => {
    setdtPageindex(1);

    if (e != null) {
       dispatch(setheSiteTransferdesignationStatus(e))
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
        dispatch(setheSiteTransferdesignationStatus({value:"",label:"ALL"}))
      }
    }
  };

  const FileterState = {
    status: state.StateManagementOverallCall.Site_TransferStatusState?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);

  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  /// console.log(state.NumberCounts, "fsdf");
  const options = [
    { value: state.NumberCounts.Option1, label: "All" },
    { value: state.NumberCounts.Option3, label: "Pending" },
    { value: state.NumberCounts.Option4, label: "Decline" },
    { value: state.NumberCounts.Option5, label: "Approved" },
  ];
  const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.StateManagementOverallCall.Site_TransferRegion
  );
  const [multiselect3, setMuliselect3] = useState(
    state.StateManagementOverallCall.Site_TransferZone
  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({
     zone: state.StateManagementOverallCall.Site_TransferZone?.value,   
       state: state.StateManagementOverallCall.Site_TransferState?.value,
 region: state.StateManagementOverallCall.Site_TransferRegion?.value

});
  const [multiselect, setMuliselect] = useState(
  state.StateManagementOverallCall.Site_TransferState
  
  );
  //--------Place---Holder----dispatch======
  useEffect(() => {
    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options));
      SetPlace("All");
    }
    if (state.NumberCounts.namerednder == "completed") {
      dispatch(setTheoptions(options[0]));
      SetPlace("Completed");
    }
    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Decline");
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Pending");
    }
  }, [state.NumberCounts.namerednder]);

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
      search: search,
      page_size: 10,
      page: dtpageindex,
      from_client: state.ClientBranchIDs.SingelEmployeelistes,
      selectVal: selectVal,
      data: data,
      user: state.ClientBranchIDs.EmployeeDetailsProfile,
      white_collar: filterForWhite.white_collar,
      // month: Datestate.month,
      // year: Datestate.year,
      // date:Datestate.date ,

      from_date: range[0],

      to_date: range[1],
    };
    dispatch(SetTheSiteTransferActions(payload));

           dispatch(
              setTablePositionPersist({
                data: payload,
                pageName: "SitetransferlistRequestedPagelist",
              })
            );

  }
  }, [
    selectVal,
    data,
    state.ClientBranchIDs.EmployeeDetailsProfile,
    filterForWhite,
    range,
    dtpageindex,
    search
  ]);




  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  // ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Cou
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      dispatch( setTheSiteTransferRegion(selectedVal));
       dispatch(setTheSiteTransferZone({ value: "", label: "ALL" }));
 
      setData({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
     dispatch( setTheSiteTransferRegion({ value: "", label: "ALL" }));
      dispatch(setTheSiteTransferZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
       dispatch(setTheSiteTransferZone(selectedVal));
 
      setData({
        ...data,
        zone: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setData({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheSiteTransferState(selectedVal));
       dispatch(setTheSiteTransferZone({ value: "", label: "ALL" }));
 

    }
  };
  const handleSelectChange = (selectedVal) => {
    console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });


      dispatch(setTheSiteTransferState(selectedVal));
     dispatch( setTheSiteTransferRegion({ value: "", label: "ALL" }));
      dispatch(setTheSiteTransferZone({ value: "", label: "ALL" }));


      setData({
        ...data,
        region: "",
        zone: "",
        state: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });


      dispatch(setTheSiteTransferState({value:"",label:"ALL"}));
      dispatch( setTheSiteTransferRegion({ value: "", label: "ALL" }));
       dispatch(setTheSiteTransferZone({ value: "", label: "ALL" }));
 
      setData({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);


   ///-----State----Input Changes
   const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};

useDebouncedEffect(
  () => {
      if (setSearchDebounance) {
          setSearched({
              ...SearchedVal,
              stateSearch: SearchDebounance.stateSearch,
              regionSearch: SearchDebounance.regionSearch,
              zoneSearch: SearchDebounance.zoneSearch,
          });
      }
  },
  500,
  [SearchDebounance]
);


  const HandleLastPage = () => {
    if (
      currentPage !=
      Math.ceil(state.SiteTransfertLists.Total_Count / dtpagesize)
    ) {
      const pageEntries = {
        search: search,
        page_size: dtpagesize,
        page: Math.ceil(state.SiteTransfertLists.Total_Count / dtpagesize),
        selectVal: selectVal,
        data: data,
        // month: Datestate.month,
        // year: Datestate.year,
        // date:Datestate.date ,
        from_date: range[0],

        to_date: range[1],
        white_collar: filterForWhite.white_collar,
      };
      dispatch(SetTheSiteTransferActions(pageEntries));
      setCurrentPage(
        Math.ceil(state.SiteTransfertLists.Total_Count / dtpagesize)
      );
      setNewpage(Math.ceil(state.SiteTransfertLists.Total_Count / dtpagesize));
    }
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

 

  const columns = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
           if(row.row.original.user_id.id != undefined && row.row.original.user_id.id != null){ 
          const userId = row.row.original.user_id.id;
          const lastFourDigits = userId.slice(-6);
          return <p>{lastFourDigits}</p>; 
           }
        },
      },
          {
      Header: filterForWhite.white_collar ? "User Name" : "Employee Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Role",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.user_role != null &&
            row.row.original.user_id.user_role != undefined ? (
              <span>{row.row.original.user_id.user_role.role}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    {
      Header: "From Branch",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.from_client != null &&
            row.row.original.from_client.client_id != undefined &&
            row.row.original.from_client.client_id.client_name != null ? (
              <span>{row.row.original.from_client.client_id.client_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "To Branch",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.to_client != null &&
            row.row.original.to_client.client_id != undefined &&
            row.row.original.to_client.client_id.client_name != null ? (
              <span>{row.row.original.to_client.client_id.client_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Reason",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.reason != null ? (
              <span>{row.row.original.reason}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Action",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  setEmployeePop(true);
                  setEmployeeIDs(row.row.original.id);
                }}
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Approve </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ],
  [sno]
    );
  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,

        status: "",
      });
      setdtPageindex(1);
       dispatch(setTheSiteTransferStateStatus({value:"",label:"ALL"}))
    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    // console.log(Counts, values, sel, "Logs");
    //console.log(SelectedValues, "selectedvaluess");
    setDisplay(SelectedValues);
    setdtPageindex(1);

    setSelected(sel);
    SetStates(true);
    dispatch(setTheSiteTransferStateStatus(SelectedValues));

    if (values == "Completed") {
      SetSelectval({
        ///Completed
        ...selectVal,

        status: "completed",
      });
    } else if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,

        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "approved",
      });
    } else if (values == "ALL") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "",
      });
    }
  };

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '1071.344px', 'important');
      rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Site Transfer</h3>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "90",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              value={multiselect}
              placeholder={"Search"}
            />
          </div>
          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>
          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                setdtPageindex(1);
                handleZone(e);
              }}
              options={nameList4}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              value={multiselect3}
              onInputChange={handleInputZone}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Zone"
              //     : data.region == ""
              //     ? "without selected Region you can't select Zone"
              //     : "Search"
              // }
            />
          </div>

          <div className="col-3">
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginBottom: "11px" }}
            >
              {/* State Name */}
              Select Date
              <span style={{ color: "red" }}>*</span>

            </label>

            <div className="datepicker_dash" style={{ marginTop: "-5px" }}>
              <DateRangePicker


defaultValue={
  state.StateManagementOverallCall.Site_TransferRange1 == ""
    ? []
    : [
        new Date(
          state.StateManagementOverallCall.Site_TransferRange1
        ),
        new Date(
          state.StateManagementOverallCall.Site_TransferRange2
        ),
      ]
}

onOpen={() => {
  openMe()
}}
onClose={() => {
CloseDateRange()
   }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    // if (diffDays === 30) {
                    //   // Since we are using inclusive range, difference should be 30 for 31 days
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else if (diffDays < 30) {
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else {
                    //   toast.error("Please select a range of exactly 31 days.", {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //   });
                    // }
                    setrange([]);
                    e.forEach((newValue) => {
                      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                      const localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>

        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.SiteTransfertLists.SiteTranfersdataList}
            columns={columns}
            totalItems={state.SiteTransfertLists.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
          dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.SiteTransfertLists.Total_Count}
            values={state.StateManagementOverallCall.Site_TransferStatusState}
            options={options}
            Filter={Filter}
            ApproveRequestFilter={true}

            count={count}
            ClearState={ClearState}
            placeHold={place}
            ///--- emoloyee role based filters -
            EmployeeRoleTrue={true}
            EmployeeRoleOption={EmpRoles}
            EMpROleSelected={state.StateManagementOverallCall.Site_Transferdesignation}
            HandleEMprole={HandleEMprole}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            searchVal={TablePositionPersist?.SitetransferlistRequestedPagelist?.search == "" || TablePositionPersist?.SitetransferlistRequestedPagelist?.search ==undefined? "":TablePositionPersist.SitetransferlistRequestedPagelist.search}
              search_key={true}
          />
        </div>
      </div>

      {EmployeePop && EmployeeIDs != undefined ? (
        <SiteTransferApprove
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={dtpageindex}
          data={data}
          EditId={EmployeeIDs}
          selectVal={selectVal}
          // Datestate={Datestate}
          from_dates={range[0]}
          to_dates={range[1]}
          white_collar={filterForWhite.white_collar}
          search={search}
        />
      ) : null}

      {createpoup ? (
        <SiteCreateEdit
          show={createpoup}
          setShow={setcreatepoup}
          currentPage={dtpageindex}
          EditId={EmployeeIDs}
          selectVal={selectVal}
          datas={data}
        />
      ) : null}
    </>
  );
};

export default SiteTransfer;
